module.exports = __webpack_public_path__ + "img/bigcommerce_2.b92fe1ba.png";